import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/cluster/inputstates", null, {}, {
    "Accept": ["application/json"]
  });
}
export function setup(inputId) {
  return __request__("PUT", `/cluster/inputstates/setup/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function start(inputId) {
  return __request__("PUT", `/cluster/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function stop(inputId) {
  return __request__("DELETE", `/cluster/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
